import { BasicLayout, BlankLayout } from '@/layouts'
// const meta = { auth: false }

export const constantRouterMap = [
  // {
  // path: '/',
  // component: BasicLayout,
  // redirect: '/',
  // name: 'Home',
  // meta: { title: '工作台', icon: '', affix: true },
  // children: [
  //   {
  //     path: '/',
  //     component: () => import('@/views/Home'),
  //     name: 'Home',
  //     meta: { title: '首页', icon: 'home', affix: true }
  //   },
  //   {
  //     path: '/about',
  //     component: () => import('@/views/About'),
  //     name: 'About',
  //     meta: { title: '关于', icon: 'home', affix: true }
  //   }

  //   // {
  //   //   path: '404',
  //   //   name: '404',
  //   //   component: () => import('@/views/exception/404')
  //   // }
  // ]
  // },
  {
    path: '/',
    component: BasicLayout,
    redirect: '/dashboard',
    name: 'Home',
    meta: { title: '首页', icon: '', affix: true },
    children: [
      {
        path: '/dashboard',
        component: () => import('@/views/dashboard'),
        name: 'Dashboard',
        meta: { title: '工作台', icon: '', affix: true }
      },
      {
        path: '/orderSearch/:type?/:data?',
        component: () => import('@/views/orderSearch/orderSearch'),
        name: 'orderSearch',
        meta: { title: '订单查询', icon: '', affix: true }
      },
      {
        path: '/storageSearch/:type?/:data?',
        component: () => import('@/views/storageSearch/storageSearch'),
        name: 'storageSearch',
        meta: { title: '仓储查询', icon: '', affix: true }
      },
      {
        path: '/tankNoSearch/tankNo-list',
        component: () => import('@/views/tankNoSearch/index'),
        name: 'TankNoSearch',
        meta: { title: '罐箱服务', icon: '', affix: true, keepAlive: true }
      },
      {
        path: '/seaTransportation/sea-transport-list',
        component: () => import('@/views/seaTransportation/index'),
        name: 'SeaTransportation',
        meta: { title: '国际海运', icon: '', affix: true }
      },
      {
        path: '/airTransport/air-transport-list',
        component: () => import('@/views/airTransport/index'),
        name: 'AirTransport',
        meta: { title: '国际空运', icon: '', affix: true }
      },
      {
        path: '/mmTransportation/mm-transport-list',
        component: () => import('@/views/mmTransportation/index'),
        name: 'MmTransportation',
        meta: { title: '国内水运', icon: '', affix: true }
      },
      {
        path: '/invoiceSearch/invoice-list',
        component: () => import('@/views/invoiceSearch/invoiceSearch'),
        name: 'InvoiceList',
        meta: { title: '发票查询', icon: '', affix: true, keepAlive: true }
      },
      {
        path: '/invoiceSearch/invoice-detail',
        component: () => import('@/views/invoiceSearch/invoice-detail.vue'),
        name: 'InvoiceDetail',
        meta: { title: '发票详情', icon: '', affix: false }
      },
      {
        path: '/contractSearch',
        component: () => import('@/views/contractSearch_new'),
        name: 'contractSearch',
        meta: { title: '合同查询', icon: '', affix: true }
      },
      {
        path: '/pointsMall',
        component: () => import('@/views/pointsMall'),
        name: 'pointsMall',
        meta: { title: '积分商城', icon: '', affix: true }
      },
      {
        path: '/productDetail',
        component: () => import('@/views/pointsMall/productDetail'),
        name: 'productDetail',
        meta: { title: '商品详情', icon: '', affix: true }
      },
      {
        path: '/exchangeRecord',
        component: () => import('@/views/exchangeRecord'),
        name: 'exchangeRecord',
        meta: { title: '历史兑换记录', icon: '', affix: true }
      },
      {
        path: '/integralSearch',
        component: () => import('@/views/integralSearch/integralSearch'),
        name: 'integralSearch',
        meta: { title: '积分查询', icon: '', affix: true }
      },
      {
        path: '/evaluateSearch',
        component: () => import('@/views/integralSearch/integralSearch'),
        name: 'evaluateSearch',
        meta: { title: '评价查询', icon: '', affix: true }
      },
      {
        path: '/dataBoard',
        component: () => import('@/views/tms/dataBoard/index'),
        name: 'dataBoard',
        meta: { title: '数据看板', icon: '', affix: true }
      },

      {
        path: '/tmsOrder',
        component: () => import('@/views/tms/tmsOrder/index'),
        name: 'tmsOrder',
        meta: { title: '订单查询', icon: '', affix: true }
      },
      {
        path: '/tmsBill',
        component: () => import('@/views/tms/tmsBill/index'),
        name: 'tmsBill',
        meta: { title: '账单查询', icon: '', affix: true }
      },
      {
        path: '/railway/ri-dashboard',
        component: () => import('@/views/railway/dashboard'),
        name: 'railwayRIDashbaord',
        meta: { title: '国际铁路', icon: '', affix: true, firstType: 'RI', keepAlive: false }
      },
      {
        path: '/railway/ri-order-list',
        component: () => import('@/views/railway/orderQuery'),
        name: 'railwayRIOrderQuery',
        meta: { title: '国际铁路订单查询', icon: '', affix: true, firstType: 'RI', keepAlive: false }
      },
      {
        path: '/railway/rd-dashboard',
        component: () => import('@/views/railway/dashboard'),
        name: 'railwayRDDashbaord',
        meta: { title: '国内铁路', icon: '', affix: true, firstType: 'RD', keepAlive: false }
      },
      {
        path: '/railway/rd-order-list',
        component: () => import('@/views/railway/orderQuery'),
        name: 'railwayRDOrderQuery',
        meta: { title: '国内铁路订单查询', icon: '', affix: true, firstType: 'RD', keepAlive: false }
      },
      {
        path: '/serviceRating',
        component: () => import('@/views/serviceRating'),
        name: 'tmsBill',
        meta: { title: '服务评价', icon: '', affix: true }
      },
      {
        path: '/feedback',
        component: () => import('@/views/feedback'),
        name: 'tmsBill',
        meta: { title: '意见反馈', icon: '', affix: true }
      },
      {
        path: '/company-info',
        component: () => import('@/views/company-info/index'),
        name: 'CompanyInfo',
        meta: { title: '公司信息', icon: '', affix: true }
      },
      {
        path: '/reset-password',
        component: () => import('@/views/reset-password/index'),
        name: 'ResetPassword',
        meta: { title: '修改密码', icon: '', affix: true }
      },
      {
        path: '/wms/wms-list',
        component: () => import('@/views/wms/index'),
        name: 'WMSList',
        meta: { title: '国内仓储-新', icon: '', affix: true }
      },
    ]
  },
  {
    path: '/unsubscribe',
    component: () => import('@/views/tms/unsubscribe/index'),
    name: 'Unsubscribe',
    meta: { title: '邮件退订', icon: '', affix: true }
  },
  {
    path: '/find-password',
    component: BlankLayout,
    meta: { title: '忘记密码', icon: '', affix: true },
    children: [
      {
        path: '',
        name: 'FindPassword',
        component: () => import('@/views/reset-password/index')
      }
    ]
  },
  {
    path: '/map-track',
    component: BlankLayout,
    name: 'mapTrack',
    meta: { title: '轨迹查看', icon: '', affix: true },
    children: [
      {
        path: '',
        name: 'MapTrack',
        component: () => import('@/views/tms/mapTrack/index')
      }
    ]
  }
  // {
  //   path: '/root',
  //   name: 'root',
  //   component: () => import('@/views/root/root')
  // },
  // {
  //   path: '/403',
  //   component: () => import('@/views/exception/403')
  // },
  // {
  //   path: '*', // 此处需特别注意置于最底部
  //   redirect: '/404'
  // }
]
